<div class="header d-flex align-center justify-space-between header-esteira" *ngIf="title && title !== lotCreated">
  <div class="header-main d-flex">
    <app-menu class="header-menu"></app-menu>

    <div class="header-copy">
      <p class="header-title main-title">
        {{ systemTitle }}
      </p>
    </div>
  </div>

  <!-- Sininho de notificações e contador de mensagens ocultados a pedido.
  <div class="header-alert alert">
    <button
      [matBadgeHidden]="badgeNumber < 1"
      [matBadge]="badgeNumber"
      matBadgeSize="medium"
      class="btn-icon alert-button button"
      (click)="showNotifications = !showNotifications">
      <app-svg-icon
        src="../../../../assets/icons/alert-icon.svg"
        width="28px"
        height="28px">
      </app-svg-icon>
    </button>

    <app-notification-modal
      class="alert-hidden"
      [ngClass]="{
        'alert-show': showNotifications,
        'fade-in': showNotifications
      }"
      [notifications]="notifications"
      (closeNotificationsEvent)="closeNotifications()"
      (changeBadgeNumberEvent)="changeBadgeNumber($event)">
    </app-notification-modal>
  </div>
  -->
</div>

<div class="header lot d-flex direction-column row-gap-8"
  *ngIf="title && title === lotCreated">
  <div class="header-main d-flex">
    <app-menu class="header-menu"></app-menu>

    <div>
      <h1 class="header-title main-title">
        {{ title }}
      </h1>

      <div *ngIf="!!lotLinked" class="header-infos d-flex">
        <span class="mr-15">
          <strong>Vinculado:</strong>
          {{ lotLinked || "-" }}
        </span>
        <span>
          <strong>Criado:</strong>
          {{ lotCreated }}
        </span>
      </div>

      <div *ngIf="legacyBatchNumber !== null" class="header-infos d-flex">
        <span class="mr-15">
          <strong>Legado Smartfin:</strong>
          {{ legacyBatchNumber }}
        </span>
      </div>
    </div>
  </div>
</div>